import React from 'react';
import { Tooltip, Fab } from '@material-ui/core';
import { CloudDownload } from '@material-ui/icons';

const DownloadReportCard = props => {
  const { downloadShared } = props;

  return <Tooltip title={`Download report`}>
    <Fab style={{ borderRadius: '1px' }} color="primary" onClick={downloadShared}>
      <CloudDownload />
    </Fab>
  </Tooltip >
};

export default DownloadReportCard;
